module.exports = __webpack_public_path__ + "img/Transportation.643c78b8.png";